import { create } from "zustand";

interface State {
  isDark: boolean;
  toggleDarkMode: () => void;
}

function getInitialIsDark(): boolean {
  if (typeof window === "undefined") return false;
  return localStorage.getItem("theme") === "dark";
}

function applyDarkClass(isDark: boolean) {
  if (typeof window === "undefined") return;
  document.documentElement.classList.toggle("dark", isDark);
}

export const darkMode = create<State>()((set, get) => {
  const isDark = getInitialIsDark();
  applyDarkClass(isDark);

  return {
    isDark,
    toggleDarkMode: () => {
      const next = !get().isDark;
      localStorage.setItem("theme", next ? "dark" : "light");
      applyDarkClass(next);
      set({ isDark: next });
    },
  };
});
